// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2AQnY","dragIcon":"SortableItem_dragIcon__3q8t4","disabled":"SortableItem_disabled__2mCHm"};